"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AtomLink = _interopRequireDefault(require("./AtomLink"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The AccountLevelBasketDelItem model module.
 * @module model/AccountLevelBasketDelItem
 * @version 3.0
 */
var AccountLevelBasketDelItem = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>AccountLevelBasketDelItem</code>.
   * @alias module:model/AccountLevelBasketDelItem
   */
  function AccountLevelBasketDelItem() {
    _classCallCheck(this, AccountLevelBasketDelItem);
    AccountLevelBasketDelItem.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(AccountLevelBasketDelItem, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>AccountLevelBasketDelItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountLevelBasketDelItem} obj Optional instance to populate.
     * @return {module:model/AccountLevelBasketDelItem} The populated <code>AccountLevelBasketDelItem</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new AccountLevelBasketDelItem();
        if (data.hasOwnProperty('basketItemId')) {
          obj['basketItemId'] = _ApiClient["default"].convertToType(data['basketItemId'], 'Number');
        }
        if (data.hasOwnProperty('catalogId')) {
          obj['catalogId'] = _ApiClient["default"].convertToType(data['catalogId'], 'Number');
        }
        if (data.hasOwnProperty('productId')) {
          obj['productId'] = _ApiClient["default"].convertToType(data['productId'], 'Number');
        }
        if (data.hasOwnProperty('subTotal')) {
          obj['subTotal'] = _ApiClient["default"].convertToType(data['subTotal'], 'Number');
        }
        if (data.hasOwnProperty('vat')) {
          obj['vat'] = _ApiClient["default"].convertToType(data['vat'], 'Number');
        }
        if (data.hasOwnProperty('total')) {
          obj['total'] = _ApiClient["default"].convertToType(data['total'], 'Number');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('unit')) {
          obj['unit'] = _ApiClient["default"].convertToType(data['unit'], 'String');
        }
        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient["default"].convertToType(data['category'], 'String');
        }
        if (data.hasOwnProperty('extendedData')) {
          obj['extendedData'] = _ApiClient["default"].convertToType(data['extendedData'], 'String');
        }
        if (data.hasOwnProperty('extendedDataXml')) {
          obj['extendedDataXml'] = _ApiClient["default"].convertToType(data['extendedDataXml'], 'String');
        }
        if (data.hasOwnProperty('effectiveFromDate')) {
          obj['effectiveFromDate'] = _ApiClient["default"].convertToType(data['effectiveFromDate'], 'Date');
        }
        if (data.hasOwnProperty('links')) {
          obj['links'] = _ApiClient["default"].convertToType(data['links'], [_AtomLink["default"]]);
        }
        if (data.hasOwnProperty('accountId')) {
          obj['accountId'] = _ApiClient["default"].convertToType(data['accountId'], 'Number');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountLevelBasketDelItem</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountLevelBasketDelItem</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['unit'] && !(typeof data['unit'] === 'string' || data['unit'] instanceof String)) {
        throw new Error("Expected the field `unit` to be a primitive type in the JSON string but got " + data['unit']);
      }
      // ensure the json data is a string
      if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
        throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
      }
      // ensure the json data is a string
      if (data['extendedData'] && !(typeof data['extendedData'] === 'string' || data['extendedData'] instanceof String)) {
        throw new Error("Expected the field `extendedData` to be a primitive type in the JSON string but got " + data['extendedData']);
      }
      // ensure the json data is a string
      if (data['extendedDataXml'] && !(typeof data['extendedDataXml'] === 'string' || data['extendedDataXml'] instanceof String)) {
        throw new Error("Expected the field `extendedDataXml` to be a primitive type in the JSON string but got " + data['extendedDataXml']);
      }
      if (data['links']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['links'])) {
          throw new Error("Expected the field `links` to be an array in the JSON data but got " + data['links']);
        }
        // validate the optional field `links` (array)
        var _iterator = _createForOfIteratorHelper(data['links']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _AtomLink["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} basketItemId
 */
AccountLevelBasketDelItem.prototype['basketItemId'] = undefined;

/**
 * @member {Number} catalogId
 */
AccountLevelBasketDelItem.prototype['catalogId'] = undefined;

/**
 * @member {Number} productId
 */
AccountLevelBasketDelItem.prototype['productId'] = undefined;

/**
 * @member {Number} subTotal
 */
AccountLevelBasketDelItem.prototype['subTotal'] = undefined;

/**
 * @member {Number} vat
 */
AccountLevelBasketDelItem.prototype['vat'] = undefined;

/**
 * @member {Number} total
 */
AccountLevelBasketDelItem.prototype['total'] = undefined;

/**
 * @member {String} currency
 */
AccountLevelBasketDelItem.prototype['currency'] = undefined;

/**
 * @member {String} unit
 */
AccountLevelBasketDelItem.prototype['unit'] = undefined;

/**
 * @member {String} category
 */
AccountLevelBasketDelItem.prototype['category'] = undefined;

/**
 * @member {String} extendedData
 */
AccountLevelBasketDelItem.prototype['extendedData'] = undefined;

/**
 * @member {String} extendedDataXml
 */
AccountLevelBasketDelItem.prototype['extendedDataXml'] = undefined;

/**
 * @member {Date} effectiveFromDate
 */
AccountLevelBasketDelItem.prototype['effectiveFromDate'] = undefined;

/**
 * @member {Array.<module:model/AtomLink>} links
 */
AccountLevelBasketDelItem.prototype['links'] = undefined;

/**
 * @member {Number} accountId
 */
AccountLevelBasketDelItem.prototype['accountId'] = undefined;
var _default = exports["default"] = AccountLevelBasketDelItem;